let domReady = (cb) => {
  document.readyState === "interactive" || document.readyState === "complete" ? cb() : document.addEventListener("DOMContentLoaded", cb);
};
domReady(() => {
  document.body.style.opacity = 1;
});
console.log("%cDesign + Dev by Jesse Hsu \nhttps://jessehsu.info", "display:block;font-family:courier;font-size:12px;font-weight:bold;line-height:1;color:white; background: black; padding: 2px");
const body = document.querySelector("body");
const trapFocusHandlers = {};
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
const overlayOpacity = document.querySelector(".overlay-opacity");
const headerDrawers = document.querySelectorAll(".header-navbar--content");
const headerToggleButtons = document.querySelectorAll(".header-navbar--toggle");
headerToggleButtons.forEach((button) => {
  button.addEventListener("click", function() {
    const targetDrawer = document.querySelector(`.${this.dataset.target}`);
    let drawerOpened = false;
    let isAnyDrawerOpen = false;
    headerDrawers.forEach((drawer) => {
      if (drawer === targetDrawer) {
        drawer.classList.toggle("open");
        drawerOpened = drawer.classList.contains("open");
      } else {
        isAnyDrawerOpen = isAnyDrawerOpen || drawer.classList.contains("open");
        drawer.classList.remove("open");
      }
    });
    if (drawerOpened || isAnyDrawerOpen) {
      overlayOpacity.classList.add("open");
      body.style.overflow = "hidden";
    } else {
      overlayOpacity.classList.remove("open");
      body.style.overflow = "";
    }
  });
});
overlayOpacity.addEventListener("click", function() {
  headerDrawers.forEach((drawer) => {
    drawer.classList.remove("open");
  });
  overlayOpacity.classList.remove("open");
  body.style.overflow = "";
});
setWindowHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
setWindowHeight();
window.addEventListener("resize", setWindowHeight);
let lazyImages = document.querySelectorAll(".lazyimg");
let imageOptions = {};
let imageObserver = new IntersectionObserver((entries, imageObserver2) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting)
      return;
    const element = entry.target;
    const imgMain = element.querySelector(".lazyimg-main");
    const imgPlaceholder = element.querySelector(".lazyimg-placeholder");
    imgMain.setAttribute("src", imgMain.getAttribute("data-src"));
    imgMain.onload = function() {
      imgMain.classList.add("is-loaded");
      imgPlaceholder.classList.add("is-loaded");
    };
    imageObserver2.unobserve(element);
  });
}, imageOptions);
lazyImages.forEach((element) => {
  imageObserver.observe(element);
});
function marquee(selector, speed) {
  const parentSelectors = document.querySelectorAll(selector);
  parentSelectors.forEach((parentSelector) => {
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    setInterval(function() {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  });
}
window.addEventListener("load", function() {
  marquee(".marquee", 0.1);
});
let accordions = document.getElementsByClassName("accordion-trigger");
for (let i = 0; i < accordions.length; i++) {
  accordions[i].addEventListener("click", function() {
    this.classList.toggle("accordion-open");
    let content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}
const tiltItems = document.querySelectorAll(".tilt");
tiltItems.forEach((item) => {
  item.addEventListener("mousemove", (event) => {
    const rect = item.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const tiltX = (x / rect.width - 0.5) * -20;
    const tiltY = (y / rect.height - 0.5) * 20;
    const shadowX = tiltX * -0.35;
    const shadowY = tiltY * -0.35;
    item.style.transform = `rotateX(${tiltY}deg) rotateY(${tiltX}deg) scale(1.25)`;
    item.style.boxShadow = `${shadowX}rem ${shadowY}rem 30rem 0rem #25C5D8`;
  });
  item.addEventListener("mouseleave", () => {
    item.style.transform = "rotateX(0deg) rotateY(0deg) scale(1)";
    item.style.boxShadow = "0.25rem 0.25rem 0.15rem 0rem #25C5D8";
  });
});
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".smooth-scroll").forEach((link) => {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      let target = document.querySelector(this.getAttribute("href"));
      console.log(target);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    });
  });
});
